import { render, staticRenderFns } from "./oz-button.vue?vue&type=template&id=7baa6d40&"
import script from "./oz-button.vue?vue&type=script&lang=ts&"
export * from "./oz-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./oz-button.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports